import React, { StrictMode } from 'react';

import { useContext as useHomeContext } from 'components/Members/Home/Context';
import Breadcrumbs from 'components/new_ui/Breadcrumbs/Index';
import TalentAssessment from './Views/TalentAssessment/Index';
import GrowthReport from './Views/GrowthReport/Index';
import LearningStyle from './Views/LearningStyle/Index';
import ExternalAssessment from './Views/ExternalAssessment/Index';

export default function Index() {
  const homeContext = useHomeContext();

  const breadcrumbs = [
    {
      name: 'Home',
      path: '/members/home',
    },
    {
      name: 'Assessments',
    },
  ];

  return (
    <StrictMode>
      <div className="content">
        {homeContext && <Breadcrumbs breadcrumbs={breadcrumbs} />}
        <section>
          <h1>Assessments</h1>
        </section>

        <TalentAssessment />

        <GrowthReport />

        <LearningStyle />

        <ExternalAssessment />
      </div>
    </StrictMode>
  );
}
